import CryptoJS from "crypto-js";

function encriptar(info) {
  // if (info == null || info == "[]") return info;
  const clave =
    typeof import.meta.env.VITE_ENCRIP_KEY !== "undefined"
      ? import.meta.env.VITE_ENCRIP_KEY
      : "CPAlb!23ty64";
  let infoEncrip = CryptoJS.AES.encrypt(JSON.stringify(info), clave).toString();
  return infoEncrip;
}

function desencriptar(infoEncrip) {
  if (infoEncrip == null || infoEncrip == "[]") return infoEncrip;
  const clave =
    typeof import.meta.env.VITE_ENCRIP_KEY !== "undefined"
      ? import.meta.env.VITE_ENCRIP_KEY
      : "CPAlb!23ty64";
  let infoDecrypted;
  try {
    infoDecrypted = CryptoJS.AES.decrypt(
      JSON.parse(infoEncrip),
      clave
    ).toString(CryptoJS.enc.Utf8);
    return infoDecrypted;
  } catch (error) {
    infoDecrypted = CryptoJS.AES.decrypt(infoEncrip, clave).toString(
      CryptoJS.enc.Utf8
    );
    return infoDecrypted.replace(/"/g, "");
  }
}

function encriptarCampo(field) {
  let i = 0;
  let found = false;
  let fieldFound = "";
  while (i < localStorage.length && !found) {
    const key = localStorage.key(i);
    if (desencriptar(key) === field) {
      found = true;
      fieldFound = key;
    }
    i++;
  }
  if (found) {
    return fieldFound;
  } else {
    return encriptar(field);
  }
}

function siExistenDatosEncriptar() {
  if (localStorage.getItem("token") !== null) {
    localStorage.setItem(
      encriptarCampo("token"),
      encriptar(localStorage.getItem("token"))
    );
  }

  if (localStorage.getItem("cliente") !== null) {
    localStorage.setItem(
      encriptarCampo("cliente"),
      encriptar(localStorage.getItem("cliente"))
    );
  }
  if (localStorage.getItem("email") !== null) {
    localStorage.setItem(
      encriptarCampo("email"),
      encriptar(localStorage.getItem("email"))
    );
  }
  if (localStorage.getItem("saleId") !== null) {
    localStorage.setItem(
      encriptarCampo("saleId"),
      encriptar(localStorage.getItem("saleId"))
    );
  }
  if (localStorage.getItem("preferenceId") !== null) {
    localStorage.setItem(
      encriptarCampo("preferenceId"),
      encriptar(localStorage.getItem("preferenceId"))
    );
  }
  if (localStorage.getItem("cartModified") !== null) {
    localStorage.setItem(
      encriptarCampo("cartModified"),
      encriptar(localStorage.getItem("cartModified"))
    );
  }
  if (localStorage.getItem("basterShopingCart") !== null) {
    let aux = localStorage.getItem("basterShopingCart");
    if (aux !== "") {
      localStorage.setItem(
        encriptarCampo("basterShopingCart"),
        JSON.stringify(encriptar(JSON.parse(aux)))
      );
    }
  }

  removerCamposAnterioresSinEncriptar();
}

function removerCamposAnterioresSinEncriptar() {
  if (localStorage.getItem("token") !== null) localStorage.removeItem("token");
  if (localStorage.getItem("cliente") !== null)
    localStorage.removeItem("cliente");
  if (localStorage.getItem("email") !== null) localStorage.removeItem("email");
  if (localStorage.getItem("saleId") !== null)
    localStorage.removeItem("saleId");
  if (localStorage.getItem("preferenceId") !== null)
    localStorage.removeItem("preferenceId");
  if (localStorage.getItem("cartModified") !== null)
    localStorage.removeItem("cartModified");
  if (localStorage.getItem("basterShopingCart") !== null)
    localStorage.removeItem("basterShopingCart");
}

export { encriptar, desencriptar, encriptarCampo, siExistenDatosEncriptar };
